document.addEventListener(
  'DOMContentLoaded',
  () => {

    const calculator =
      document.querySelector(
        '.shipping-calculator'
      );

    if (!calculator) return;

    const input =
      calculator.querySelector(
        '.shipping-calculator__input'
      );

    const button =
      calculator.querySelector(
        '.shipping-calculator__button'
      );

    const result =
      calculator.querySelector(
        '.shipping-calculator__result'
      );

    if (
      !input ||
      !button ||
      !result
    ) {
      return;
    }

    /* ==========================
       HELPERS
    ========================== */

    function showMessage(
      message
    ) {

      result.classList.remove(
        'is-loading'
      );

      result.innerHTML =
        message;

      result.classList.add(
        'is-error'
      );

      setTimeout(() => {

        result.classList.remove(
          'is-error'
        );

      }, 400);

    }

    function scrollToRates() {

  requestAnimationFrame(() => {

    result.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

  });

}

function getVariantId() {

  const lookVariantInput =
    document.querySelector(
      '[data-look-form] [data-look-variant-id]'
    );

  if (
    lookVariantInput?.value &&
    Number(lookVariantInput.value) > 0
  ) {
    return lookVariantInput.value;
  }

  const selectedLookVariant =
    document.querySelector(
      '.look-enterprise__variant input[data-look-variant]:checked'
    );

  if (
    selectedLookVariant?.value &&
    Number(selectedLookVariant.value) > 0
  ) {
    return selectedLookVariant.value;
  }

  const defaultVariant =
    document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

  if (
    defaultVariant?.value &&
    Number(defaultVariant.value) > 0
  ) {
    return defaultVariant.value;
  }

  return null;
}

async function getCepData(
  zip
) {

  const cached =
    ShippingCache.getCep(
      zip
    );

  if (cached) {
    return cached;
  }

  const response =
    await fetch(
      `https://viacep.com.br/ws/${zip}/json/`
    );

  const data =
    await response.json();

  if (data.erro) {
    throw new Error(
      'CEP_NOT_FOUND'
    );
  }

  ShippingCache.saveCep(
    zip,
    data
  );

  return data;

}

    function renderRates(rates) {

  result.innerHTML =
    rates.map(rate => {

      const name =
        rate.name.toLowerCase();

      const hasCustomDeadline =
        name.includes('entrega rápida') ||
        name.includes('motoboy') ||
        name.includes('same day') ||
        name.includes('retirada');

      const deliveryDays =
        rate.delivery_days
          ? parseInt(
              String(rate.delivery_days),
              10
            )
          : null;

      const deadline =
        (
          deliveryDays &&
          !hasCustomDeadline
        )
          ? `
              <span class="shipping-rate__deadline">
                Entrega em até
                ${deliveryDays}
                ${
                  deliveryDays > 1
                    ? ' dias úteis'
                    : ' dia útil'
                }
              </span>
            `
          : '';

      return `
        <div class="shipping-rate">

          <div>

            <strong>
              ${rate.name}
            </strong>

            ${deadline}

          </div>

          <span>
            ${ShippingUtils.formatPrice(
              rate.price
            )}
          </span>

        </div>
      `;

    }).join('');

}

    /* ==========================
       CÁLCULO
    ========================== */

    async function calculate() {

      if (
        button.disabled
      ) {
        return;
      }

      const zip =
        input.value
          .replace(/\D/g, '');

const variantId =
  getVariantId();

if (!variantId) {

  return showMessage(
    'Selecione um tamanho antes.'
  );

}
      if (
        zip.length !== 8
      ) {

        return showMessage(
          'Digite um CEP válido.'
        );

      }

      const cached =
        ShippingCache.getShipping(
          zip,
          variantId
        );

      if (cached) {

        renderRates(
          cached
        );

        scrollToRates();

        return;

      }

      button.disabled = true;

      result.classList.add(
        'is-loading'
      );

      result.innerHTML =
        'Calculando frete...';

      let temporary =
        false;

      try {

        const cart =
          await ShippingUtils.getCart();

        if (
          cart.item_count === 0
        ) {

          await ShippingCart
            .addTemporaryProduct(
              variantId
            );

          temporary = true;

        }

        const cepData =
          await getCepData(
            zip
          );

await ShippingUtils.postJson(
  '/cart/update.js',
  {
    attributes: {
      shipping_zip: zip,
      shipping_street:
        cepData.logradouro || '',
      shipping_neighborhood:
        cepData.bairro || '',
      shipping_city:
        cepData.localidade || '',
      shipping_state:
        cepData.uf || ''
    }
  }
);

await ShippingUtils.postJson(
  '/cart/prepare_shipping_rates.json',
  {
    shipping_address: {
      zip,
      address1:
        cepData.logradouro || '',
      city:
        cepData.localidade || '',
      province:
        cepData.uf || '',
      country: 'Brazil'
    }
  }
);
        let rates = [];

        for (
          let i = 0;
          i < 10;
          i++
        ) {

          const response =
            await fetch(
              `/cart/async_shipping_rates.json?shipping_address[zip]=${zip}`,
              {
                cache:
                  'no-store'
              }
            );

          const data =
            await response.json();

          if (
            data.shipping_rates
              ?.length
          ) {

            rates =
              data.shipping_rates;

            break;

          }

          await ShippingUtils.wait(
            1200
          );

        }

        rates =
          rates.filter(
            rate =>
              Number(
                rate.price
              ) > 0
          );

        if (
          !rates.length
        ) {

          return showMessage(
            'Nenhuma opção encontrada.'
          );

        }

        ShippingCache
          .saveShipping(
            zip,
            variantId,
            rates
          );

        renderRates(
          rates
        );
        
        scrollToRates();

      } catch (
        error
      ) {

        console.error(
          error
        );

        showMessage(

          error.message ===
            'CEP_NOT_FOUND'

            ? 'CEP não encontrado, tente novamente.'

            : 'Erro ao calcular, tente novamente.'

        );

      } finally {

        if (
          temporary
        ) {

          try {

            await ShippingCart
              .removeTemporaryProduct();

          } catch (
            error
          ) {

            console.error(
              error
            );

          }

        }

        ShippingCart
          .closeDrawer();

        result.classList.remove(
          'is-loading'
        );

        button.disabled =
          false;

      }

    }

    /* ==========================
       EVENTOS
    ========================== */

    input.addEventListener(
      'input',
      () => {

        input.value =
          input.value
            .replace(
              /\D/g,
              ''
            )
            .replace(
              /^(\d{5})(\d)/,
              '$1-$2'
            )
            .slice(
              0,
              9
            );

      }
    );

    input.addEventListener(
      'keydown',
      event => {

        if (
          event.key !==
          'Enter'
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        calculate();

      },
      true
    );

    const form =
      input.closest(
        'form'
      );

    form?.addEventListener(
      'submit',
      event => {

        event.preventDefault();

        calculate();

      }
    );

    button.addEventListener(
      'click',
      calculate
    );

  }
);